var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-alert"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert",
    clipPath: "url(#clip-alert)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(0.102 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31626",
    "data-name": "Path 31626",
    d: "M25.524,27.091H4.218A4.219,4.219,0,0,1,.444,20.985L11.1,2.746a4.219,4.219,0,0,1,7.548,0L29.3,20.985a4.219,4.219,0,0,1-3.774,6.106Zm0,0",
    transform: "translate(0 -0.001)",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31628",
    "data-name": "Path 31628",
    d: "M224.7,346.743a2.052,2.052,0,1,1-2.052-2.052A2.052,2.052,0,0,1,224.7,346.743Zm0,0",
    transform: "translate(-207.779 -324.271)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31630",
    "data-name": "Path 31630",
    d: "M222.65,71.035a2.052,2.052,0,0,1,2.052,2.052v9.747a2.052,2.052,0,0,1-4.1,0V73.087A2.052,2.052,0,0,1,222.65,71.035Zm0,0",
    transform: "translate(-207.779 -66.518)",
    fill: "#35495e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.6aa7cab9c965e5f4eca0821ecf78ec87.svg";
export { ForwardRef as ReactComponent };